<template>
    <div>
        <CuentaAtras @tiempoTerminado="tiempoTerminado"/>
        <PageTitle 
            :title="$t('nuevo_abono.titulo', { temporada: lista_abonados.nombre, abono: teatro.texto_abono })" 
            class="strech"
        />
        <section class="padding-vertical-content">
            <Stepper 
                ref="stepper"
                :steps="steps" 
            >
                <template #pasoSector="{ changeStep }">
                    <SeleccionarZonaComponent
                        @zonaSeleccionada="(zona) => { 
                            zona_seleccionada = zona; 
                            changeStep(); 
                        }"
                    />                   
                </template>
                <template #pasoAsiento="{ changeStep }">
                    <SeleccionarAsientosSga
                        :zona="zona_seleccionada"
                        @sesionCreada="items => {
                            items_carrito = items
                            changeStep();
                        }"
                        @volver="() => {
                            zona_seleccionada = null;
                            eliminarDatos();
                            changeStep(true);
                        }"
                    />
                </template>
                <template #pasoDatos="{ changeStep }">
                    <DatosAbonosSGAComponent
                        :items_carrito="items_carrito"
                        @setDatosCobro="(jet_id, formulario, session_id) => {
                            setDatosCobro(jet_id, formulario, session_id);
                            changeStep();
                        }"
                        @volver="() => {
                            eliminarDatos();
                            changeStep(true);
                        }"
                    />
                </template>
                <template #pasoResumen="{ changeStep }">
                    <ResumenCompra
                        :abonos="items_carrito"
                        :jet_id="jet_id"
                        :formulario="formulario"
                        @terminado="() => {
                            changeStep();
                        }"
                        @volver="() => {
                            changeStep(true);
                        }"
                    />
                </template>
                <template #pasoTarjeta>
                    <ProcesarPago 
                        :jet_id="jet_id"
                        :session_id="session_id"
                        @terminado="() => {
                            changeStep();
                        }"
                    />
                </template>
            </Stepper>
        </section>
    </div>
</template>

<script>
    import CuentaAtras from '@/components/frontend/events/compra/CuentaAtras';
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import Stepper from '@/components/frontend/events/compra/components/Stepper.vue';
    import SeleccionarZonaComponent from './SeleccionarZonaComponent.vue';
    import SeleccionarAsientosSga from './SeleccionarAsientosSga.vue';
    import DatosAbonosSGAComponent from './DatosAbonosSGAComponent';
    import ResumenCompra from './ResumenCompra';
    import ProcesarPago from './ProcesarPago';

    export default {
        data() {
            return {
                zona_seleccionada: null,
                items_carrito: null,
                session_id: null,
                formulario: null,
                jet_id: null
            }
        },
        computed: {
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            teatro(){
                return this.$store.getters.getTeatro;
            },
            steps() {
                return [
                    { label: this.$t('abonados.seleccionar_sector'), slot: 'paso-archivo' },
                    { label: this.$t('abonados.seleccionar_asientos'), slot: 'paso-grupo' },
                    { label: this.$t('abonados.rellenar_datos'), slot: 'paso-grupo' },
                    { label: this.$t('abonados.resumen'), slot: 'paso-grupo' }
                ]
            }
        },
        methods: {
            tiempoTerminado() {
                alert('Volver');
            },
            eliminarDatos() {
                if (localStorage.getItem('sga_abono_cart_id')) {
                    this.$store.dispatch(this.config.getVuexAlias('sga.cart.eliminar-datos'), { cart_id: localStorage.getItem('sga_abono_cart_id') }).then(() => {})
                        .catch(error => {
                            console.log('Error al eliminar los datos:', error);
                        });
                }
                localStorage.removeItem('sga_abono_cart_id');
            },
            setDatosCobro(jet_id, formulario, session_id) {
                this.jet_id = jet_id;
                this.formulario = formulario;
                this.session_id = session_id;
            }
        },
        mounted() {
            this.eliminarDatos();

            if (this.teatro.tipo_tpv === 2) {
                this.steps.push({ label: "Datos de pago", slot: "pasoTarjeta" });
            }
        },
        components: {
            CuentaAtras, PageTitle, Stepper, SeleccionarZonaComponent, SeleccionarAsientosSga, DatosAbonosSGAComponent, ResumenCompra, ProcesarPago
        }
    }
</script>